import { Box, Typography } from "@mui/material";

export function formatNoteTimestamp(value) {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function appointmentOptionLabel(appointment) {
  const when = appointment?.date
    ? new Date(appointment.date).toLocaleString("en-US", {
        weekday: "short",
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      })
    : "Unknown time";
  const services = (appointment?.services || [])
    .map((service) => service.serviceName)
    .filter(Boolean);
  const stylist = [appointment?.stylistName, appointment?.stylistLastName]
    .filter(Boolean)
    .join(" ");
  return [when, services.join(", "), stylist].filter(Boolean).join(" — ");
}

export function noteContextLabel(note) {
  const appointment = note?.appointment;
  if (!appointment) return "General";
  const when = formatNoteTimestamp(appointment.date);
  const services = (appointment.services || []).filter(Boolean).join(", ");
  const stylist = [appointment.stylist_name, appointment.stylist_last_name]
    .filter(Boolean)
    .join(" ");
  return [when, services, stylist].filter(Boolean).join(" — ") || "Appointment";
}

export function ClientNotesList({ notes, loading, emptyText, minHeight = 160 }) {
  return (
    <Box sx={{ minHeight, maxHeight: 280, overflowY: "auto" }}>
      {loading ? (
        <Typography variant="body2" color="text.secondary">
          Loading notes…
        </Typography>
      ) : notes.length === 0 ? (
        <Typography variant="body2" color="text.secondary">
          {emptyText}
        </Typography>
      ) : (
        notes.map((note, index) => (
          <Box
            key={note.id}
            sx={{
              py: 1.25,
              borderBottom: index < notes.length - 1 ? "1px solid" : "none",
              borderColor: "divider",
            }}
          >
            <Typography variant="caption" color="text.secondary" fontWeight={600}>
              {formatNoteTimestamp(note.created_at)}
              {" · "}
              {noteContextLabel(note)}
            </Typography>
            <Typography
              variant="body2"
              sx={{ mt: 0.5, whiteSpace: "pre-wrap", lineHeight: 1.45 }}
            >
              {note.note}
            </Typography>
          </Box>
        ))
      )}
    </Box>
  );
}
